import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { Button, Loading, Module, ModuleBody, ModuleHeader } from '@wfp/ui';

import { type Section } from '../../restapi/types';
import { getSectionVersions } from '../../restapi/section';
import { SectionView } from './SectionView';
import { formatTimestamp } from '../../utils';


interface Props {
	section: Section;
}


export function SectionVersions(props: Props) {
	const {section: sec} = props;
	const [showVersions, setShowVersions] = useState(false);

	const query = useQuery(['sectionVersions', sec.id], () => getSectionVersions(sec.id), {
		enabled: showVersions,  // The query will not execute until showVersions
	});

	const versions = query.data;

	return (
		<div>
			<div className="center">
				<Button className="my" onClick={() => setShowVersions(!showVersions)} small kind="ghost">
					{showVersions ? 'Hide all previous versions' : 'Show all previous versions'}</Button>
			</div>
			{showVersions ?
				query.isLoading ?
					<div className="center">
						<Loading withOverlay={false} active small/>
					</div> :
					(versions && versions.length) ?
						versions.map((v, i) =>
							<Module>
								<ModuleHeader>
									Version nr. {versions.length - i}
									<p className="note">Created by <strong>{v.author}</strong> form
										status <strong>{v.state}</strong> on <strong>{formatTimestamp(v.date)}</strong>
									</p>
								</ModuleHeader>
								<ModuleBody>
									<SectionView section={v}/>
								</ModuleBody>
							</Module>,
						) : <Module>
							<ModuleBody>
								There are no previous versions for this section
							</ModuleBody>
						</Module>
				: null
			}
		</div>
	);
}